import React from 'react';
import {
  Box,
  Flex,
  Text,
  IconButton,
  useColorModeValue,
  Badge,
  Avatar,
  HStack,
  VStack,
  Tooltip,
} from '@chakra-ui/react';
import { ViewIcon, PhoneIcon } from '@chakra-ui/icons';

const DoctorCard = ({ doctor, onView }) => {
  const bg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.100', 'gray.700');
  const accentColor = useColorModeValue('blue.500', 'blue.300');

  return (
    <Box
      p={5}
      bg={bg}
      borderWidth="1px"
      borderColor={borderColor}
      borderRadius="2xl"
      shadow="sm"
      transition="all 0.3s ease"
      _hover={{
        shadow: 'xl',
        transform: 'translateY(-4px)',
        borderColor: 'blue.400',
      }}
      position="relative"
      overflow="hidden"
    >
      {/* Decorative Accent Gradient */}
      <Box
        position="absolute"
        top={0}
        left={0}
        w="4px"
        h="100%"
        bgGradient={`linear(to-b, ${accentColor}, cyan.400)`}
      />

      <Flex justify="space-between" align="center">
        <HStack spacing={4}>
          <Avatar
            name={doctor.name}
            src={doctor.image}
            size="md"
            border="2px solid"
            borderColor="blue.50"
          />
          <VStack align="start" spacing={0}>
            <HStack>
              <Text fontWeight="bold" fontSize="lg" letterSpacing="tight">
                Dr. {doctor.name}
              </Text>
              <Badge
                colorScheme={doctor.isActive ? 'green' : 'red'}
                variant="subtle"
                borderRadius="full"
                px={2}
              >
                {doctor.isActive ? 'Active' : 'Inactive'}
              </Badge>
            </HStack>

            <HStack color="gray.500" fontSize="xs">
              <PhoneIcon w={3} h={3} />
              <Text>{doctor.mobile}</Text>
            </HStack>
          </VStack>
        </HStack>

        <VStack align="end" spacing={3}>
          <Box textAlign="right">
            <Text
              fontSize="xs"
              color="gray.400"
              textTransform="uppercase"
              fontWeight="bold"
            >
              Patients
            </Text>
            <Text
              fontSize="xl"
              fontWeight="black"
              color={accentColor}
              lineHeight="1"
            >
              {doctor.patientCount}
            </Text>
          </Box>

          <Tooltip label="View Patient List" placement="top" hasArrow>
            <IconButton
              aria-label="View patients"
              icon={<ViewIcon />}
              colorScheme="blue"
              size="sm"
              rounded="full"
              variant="ghost"
              _hover={{ bg: 'blue.50', color: 'blue.600' }}
              onClick={onView}
            />
          </Tooltip>
        </VStack>
      </Flex>
    </Box>
  );
};

export default DoctorCard;
